import { Component } from 'react';
import { withRouter} from "react-router-dom";
import {ApsResponseDownloadFormContext} from './ApsReportDownloadContext'
import ApsReportService from "../../services/apsReport.service";
import ApsReportSelectionService from "../../services/apsReportSelection.service";
import GetErrorMessage  from '../../helpers/error-message'
import {ShowError, ShowSuccess} from "../../components/toast"
import ValidateApsResponseDownload from './ApsReportDownloadValidation'
import MySavedFilter from '../../components/MySavedFilter/MySavedFilterComponent';
import Modal from 'app/components/Modal';
import SelectionFilters from './SelectionFiltersModel'
import MySavedFilterModel from './MySavedFiltersModel'
import { Button} from 'app/components/Basics/';
import Filters from './components/Filters/FiltersComponent';
import { GlobalStateContext } from 'app/contexts/GlobalStateContext';

class ApsResponseDownloadForm extends Component { 
    static contextType = GlobalStateContext;   
    constructor(props){
        super(props);
        this.state = {
            showFiltersModal: false,            
            selectedSelectionFilters: SelectionFilters(),
            selectedMySavedFilter: MySavedFilterModel(),
            errors: [],
            deleteModalText: ''
        }        
    }

    cleanSelectedFilters() {
		this.setState({ 
            selectedSelectionFilters: SelectionFilters(),
            selectedMySavedFilter: MySavedFilterModel()
        });
	}

    openFiltersModal() {
		this.setState({ showFiltersModal: true });
	}	

	closeFiltersModal() {		
		this.setState({ showFiltersModal: false });
	}    

        updateSelectedSelectionFilters(selectedSelectionFilters) {
		this.setState({selectedSelectionFilters: selectedSelectionFilters})
    }

        updateSelectedMySavedFilter(selectedMySavedFilter) {
		this.setState({selectedMySavedFilter: selectedMySavedFilter})
    }

    downloadResponses(apsResponseDownloadSet) {                
        this.props.toggleUiBlock(true);
        ApsReportService.generate(apsResponseDownloadSet)
            .then(response => {
                const { addFileDownloadJobId } = this.context;
                addFileDownloadJobId(response.jobId);
                this.props.toggleUiBlock(false);
            })
            .catch(error => {
                let errorMessage = GetErrorMessage(error);
                console.log("errorMessage on catch");
                console.log(errorMessage);
                this.props.toggleUiBlock(false);
                this.setState({ errorMessage: errorMessage});
            });
    }

    saveFilters(selectedMySavedFilter) {                
        this.props.toggleUiBlock(true);
        if (selectedMySavedFilter.id) {
            ApsReportSelectionService.updateResponseSelection(selectedMySavedFilter)
                .then(response =>{                    
                    this.props.toggleUiBlock(false);
                    this.setState({successMessage: 'The selection was saved successfully' });                    
                    this.props.queryMySelectionFilters();
                })
                .catch(error => {
					let errorMessage = GetErrorMessage(error);
					console.log("errorMessage on catch");
					console.log(errorMessage);
					this.props.toggleUiBlock(false);
					this.setState({ errorMessage: errorMessage});
                });
        }
        else {            
            ApsReportSelectionService.createResponseSelection(selectedMySavedFilter)
                .then(response => {					
                    const selectedMySavedFilter = response.data;
                    this.props.toggleUiBlock(false);
                    this.setState({successMessage: 'The selection was created successfully' });                                        
                    this.setState({selectedMySavedFilter: selectedMySavedFilter});
                    this.props.queryMySelectionFilters();
					
                })
                .catch(error => {
					let errorMessage = GetErrorMessage(error);
					console.log("errorMessage on catch");
					console.log(errorMessage);
					this.props.toggleUiBlock(false);
					this.setState({ errorMessage: errorMessage});
                });
        }

    }    

    handleSubmitAction = event => {        
        var validationErrors = ValidateApsResponseDownload(this.state.selectedSelectionFilters);
        this.setState({errors: validationErrors});
        if (validationErrors && validationErrors.length === 0) {                    
            this.downloadResponses(this.state.selectedSelectionFilters);
        }
        return;
    }

    handleSaveFilters = event => {
        var validationErrors = ValidateApsResponseDownload(this.state.selectedSelectionFilters);
        this.setState({errors: validationErrors});
        if (validationErrors && validationErrors.length === 0) {
            var selectedMySavedFilter = this.state.selectedMySavedFilter
            selectedMySavedFilter.selectionFilters = this.state.selectedSelectionFilters;
            this.setState({ selectedMySavedFilter: selectedMySavedFilter });
            this.saveFilters(this.state.selectedMySavedFilter);
        }
        return;
    }    

    handleDeleteFilters = event => {
		//if (this.props.canChangeData) {    
        	this.setState({ deleteModalText: `Are you sure you want to delete the selection with name '${this.state.selectedMySavedFilter.name}'?`});
		//}
    }

    hideDeleteModal() {
        this.setState({deleteModalText: ''})
    }

    confirmDelete() {        
        this.hideDeleteModal();
        this.props.toggleUiBlock(true);        
        ApsReportSelectionService.deleteResponseSelection(this.state.selectedMySavedFilter)
        .then(response =>{            
            this.setState({successMessage: 'The selection was deleted successfully' });            
            this.props.queryMySelectionFilters();
			setTimeout(() => {
                this.cleanSelectedFilters();
				this.props.toggleUiBlock(false);						
			}, 2000);

            
        })
        .catch(error => {
            let errorMessage = GetErrorMessage(error);
            console.log("errorMessage on catch");
            console.log(errorMessage);
            this.props.toggleUiBlock(false);
            this.setState({ errorMessage: errorMessage});
        });
    }

    isDisabled() {
		if (!this.state.selectedSelectionFilters) {
			return true;
		}
		var errors = ValidateApsResponseDownload(this.state.selectedSelectionFilters);
		if (errors?.length > 0) {
			return true;
		} 
		else {
			return false;
		}
	}
    
    render() {    
        return (
            <div className="AppFormComponent ApsResponseDownloadForm">                 
                <ApsResponseDownloadFormContext.Provider value={{
					updateSelectedSelectionFilters: this.updateSelectedSelectionFilters.bind(this), 
                    updateSelectedMySavedFilter: this.updateSelectedMySavedFilter.bind(this),
					selectedSelectionFilters: this.state.selectedSelectionFilters,
                    selectedMySavedFilter: this.state.selectedMySavedFilter,
                    mySavedFilters: this.props.mySavedFilters,
					canChangeData: this.props.canChangeData}}>
                    <form ref={ form => this.formEl = form } onSubmit={ this.handleSubmitAction }>
                        <div className="form-head">      
                            <div className="form-row downloadResponsesHeader">
					            Download Responses
				            </div>
                            <MySavedFilter 
                                mySavedFilters={this.props.mySavedFilters} 
                                handleSaveFilters={this.handleSaveFilters.bind(this)}
                                handleDeleteFilters={this.handleDeleteFilters.bind(this)} 
                                queryMySelectionFilters={this.props.queryMySelectionFilters.bind(this)}
                                updateSelectedMySavedFilter={this.updateSelectedMySavedFilter.bind(this)}
                                updateSelectedSelectionFilters={this.updateSelectedSelectionFilters.bind(this)}
                                MySavedFilter={MySavedFilter.bind(this)}
                                SelectionFilters={SelectionFilters.bind(this)}
                                selectedMySavedFilter={this.state.selectedMySavedFilter}
                                ValidateFilter={ValidateApsResponseDownload.bind(this)}
                                selectedSelectionFilters= {this.state.selectedSelectionFilters}
                            />
                            <div>                            
                                <Filters key={this.state.selectedMySavedFilter?.id} metadata={this.props.metadata}></Filters>				
                                <div className="form-row" style={{paddingTop:20}}>
                                    <div className="form-row-left">
                                        <Button disabled={this.isDisabled()} title="Download responses data as a CSV file" onClick={this.handleSubmitAction.bind(this)}>Download Data</Button>
                                    </div>					
                                </div>
                            </div>
                        </div>
                    </form>                    
                </ApsResponseDownloadFormContext.Provider>
                
                {this.state.errorMessage && ( <ShowError clearErrorMessage={() => this.setState({errorMessage: ''})} errorMessage={this.state.errorMessage} /> )}
                {this.state.successMessage && ( <ShowSuccess clearMessage={() => this.setState({successMessage: ''})} message={this.state.successMessage} /> )}                
                {this.state.deleteModalText && ( <Modal content={this.state.deleteModalText} size="small" confirmModalHandler={this.confirmDelete.bind(this)} cancelModalHandler={this.hideDeleteModal.bind(this)} />)}
            </div>            
        );
    }
}

export default withRouter(ApsResponseDownloadForm); 